import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About";
//import NotFound from "../views/404.vue";
import Method from "../views/Method.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/countries/:countryIdentifier",
    name: "countryView",
    component: Home,
    props: true,
    redirect: "/countries/:countryIdentifier/primary/adm0",
    children: [
      {
        path: ":facilityType",
        name: "facilityCountryView",
        component: Home,
        props: true,
        redirect: "/countries/:countryIdentifier/:facilityType/adm0",
        children: [
          {
            path: ":scaleType",
            name: "lol",
            component: Home,
            props: true
          }
        ]
      }
    ]
  },
  {
    path: "/method",
    name: "Method",
    component: Method
  },
  {
    path: "/about",
    name: "About",
    component: About
  }
];

const router = new VueRouter({
  routes
});

export default router;
